<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-item-group(:value="info.contact_type" @change="updateInfo({contact_type: $event})")
        v-row.padding-for-list-btn
          v-item( v-for="(type, index) in typeContact" :key="index")
            v-card(slot-scope="{ active, toggle }"
            :color="active ? 'primary' : ''" light width="120" height="50" @click="toggle" class="align-center").margin-8
              div(:class="active ? 'change-to-white-color' : ''").class-text-align-center {{type.name}}

      v-row
        v-col(cols="12" sm="6")
          table#table-left.app-table-basic-slim.biz-table
            tbody
              tr
                td.w50per.td-left.td-top.biz-title
                  span.sum-label {{$t('contact.info.customer')}}
                  span.red--text *
                td.w50per.td-right.align-right.td-top
                  v-combobox(
                    autocomplete="off"
                    autofocus
                    :items="customers"
                    hide-details
                    item-text="name"
                    item-value="id"
                    return-object
                    :value="info.customer"
                    @change="UpdateInfoCustomer({customer: $event})"
                    :rules="[rules.required]"
                    ref="customers"
                    em="a.1"
                    validate-on-blur)
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.customer_member_input')}}
                td.w50per.td-right.align-right
                  v-text-field.min-height-auto(
                  hide-details
                  :value="info.customer_member_input"
                  ref="customer_member_input"
                  @change="updateInfo({customer_member_input: $event})"
                  em="a.2"
                  )
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.auction_date')}}
                  span.red--text *
                td.w50per.td-right.align-right
                  v-text-field.min-height-auto(
                  hide-details
                  :rules="[rules.required,rules.date]"
                  ref="auction_date"
                  :value="info.auction_date"
                  @change="updateInfo({auction_date: $event})"
                  @keydown.enter="updateInfo({auction_date:pickDate(info.auction_date)})"
                  type="text"
                  em="a.3"
                  )
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.contact_date')}}
                td.w50per.td-right.align-right
                  v-layout(row wrap align-center)
                    v-flex(xs7).padding-top-0
                      v-text-field.min-height-auto(
                        hide-details
                        :rules="[rules.date]"
                        :value="info.contact_date"
                        @change="updateInfo({contact_date: $event})"
                        @keydown.enter="updateInfo({contact_date:pickDate(info.contact_date)})"
                        type="text"
                        ref="contact_date"
                        em="a.4"
                      )
                    v-flex(xs4).padding-top-0
                      div(class="v-input")
                        cleave(
                          hide-details
                          :value="info.contact_time"
                          ref="contact_time"
                          :options="options_contact_time"
                          em="a.5"
                          class="c-input-time"
                          placeholder="00:00"
                          autocomplete="off"
                        )
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.member')}}
                  span.red--text *
                td.w50per.td-right.align-right
                  v-autocomplete(
                    autocomplete="off"
                    hide-details
                    :items="members"
                    :value="info.member"
                    @change="updateInfo({member: $event})"
                    item-text="name"
                    :rules="[rules.required]"
                    item-value="id"
                    ref="member"
                    return-object
                    em="a.6"
                  )
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.memo')}}
                td.w50per.td-right.align-right
                  v-text-field.min-height-auto(
                  hide-details
                  :value="info.memo"
                  @change="updateInfo({memo: $event})"
                  type="text"
                  ref="memo"
                  em="a.13"
                  )
              tr
                td.w50per.td-left.biz-title
                  span.sum-label {{$t('contact.info.reminder')}}
                td.w50per.td-right.align-right
                  v-layout(row wrap align-center)
                    v-flex(xs7).padding-top-0
                      v-text-field.min-height-auto(
                        hide-details
                        :rules="[rules.date]"
                        :value="info.reminder_date"
                        @change="updateInfo({reminder_date: $event})"
                        @keydown.enter="updateInfo({reminder_date:pickDate(info.reminder_date)})"
                        type="text"
                        ref="reminder_date"
                        em="a.14"
                      )
                    v-flex(xs4).padding-top-0
                      div(class="v-input")
                        cleave(
                          :value="info.reminder_time"
                          ref="reminder_time"
                          :options="options_reminder_time"
                          hide-details
                          em="a.15"
                          class="c-input-time"
                          placeholder="00:00"
                          autocomplete="off"
                        )
        v-col.table-wrapper(cols="12" sm="6" :style="{height: tableRightHeight, overflow: 'auto'}")
          table#table-right.app-table-basic-slim.biz-table
            tbody
              tr
                td.w10per.td-left.td-right.td-top.product-title
                  v-checkbox(v-model="checkAll")
                td.w80per.td-right.td-top.product-title(colspan="2")
                  div.d-inline-block.sum-label.pt-1.product-title__title {{$t('contact.info.product')}}({{getContactProducts.length}})
                  div.d-inline-block.align-right.product-title__action
                    v-btn(outlined @click="addProductItem") {{$t('add')}}
                    v-btn(outlined color="error" @click="removeProductItem") {{$t('remove')}}
              ProductItem(v-for="(item, index) in info.contact_products" :key="index"
                v-show="item.removed !== true"
                :contactProduct="item"
                :items="items"
                :countries="countries" :genuses="genuses" :units="units"
                :boxTypes="boxTypes" :suppliers="suppliers" :index="index"
                @check="check"
                ref="pdItem"
              )

</template>

<script>
import rules from '@/common/mixins/rules'
import datepick from '@/common/mixins/datepick'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import Entermove from '@/common/mixins/entermove'
import ProductItem from './ProductItem'
import Cleave from 'vue-cleave-component'

export default {
  components: {ProductItem, Cleave},
  mixins: [rules, datepick, Entermove],
  data () {
    return {
      options_contact_time: {
        time: true,
        timePattern: ['h', 'm'],
        onValueChanged: ($event) => {
          this.updateInfo({contact_time: $event.target.value})
        }
      },
      options_reminder_time: {
        time: true,
        timePattern: ['h', 'm'],
        onValueChanged: ($event) => {
          this.updateInfo({reminder_time: $event.target.value})
        }
      },
      tableRightHeight: '',
      selectedRow: []
    }
  },
  props: {
    customers: {
      type: Array,
      required: true
    },
    typeContact: {
      type: Array,
      required: true
    },
    members: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    genuses: {
      type: Array,
      required: true
    },
    units: {
      type: Array,
      required: true
    },
    boxTypes: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    }
  },
  mounted () {
    let tableLeftHeight = document.getElementById('table-left').clientHeight
    this.tableRightHeight = tableLeftHeight + 'px'
  },
  computed: {
    ...mapGetters('app/ct', ['info', 'getContactProducts']),
    checkAll: {
      get: function () {
        if (this.info.contact_products.length === 0) return false
        return this.selectedRow.length === this.info.contact_products.length
      },
      set: function (value) {
        const selected = []

        if (value) {
          for (let i in this.$refs.pdItem) {
            selected.push(Number(i))
            this.$refs.pdItem[i].isChecked = true
          }
        } else if (!value && this.selectedRow.length) {
          for (let i of this.selectedRow.length) {
            this.$refs.pdItem[i].isChecked = false
          }
        }

        this.selectedRow = selected
      }
    }
  },
  methods: {
    ...mapMutations('app/ct', ['updateInfo', 'addItemToArrayState', 'addContactProduct', 'removeContactProduct']),
    ...mapActions('app/ct', ['updateInfo']),
    UpdateInfoCustomer (item) {
      if (item.customer.id > -1) {
        this.updateInfo(item)
      } else {
        this.updateInfo({customer_input: item.customer})
      }
    },
    check (index, payload) {
      if (payload && !this.selectedRow.includes(index)) {
        this.selectedRow.push(index)
      }
      if (!payload) {
        this.selectedRow = this.selectedRow.filter(val => val !== index)
      }
    },
    async addProductItem () {
      this.addContactProduct()
      await this.$nextTick()
      let container = document.querySelector('.table-wrapper')
      container.scrollTo({top: container.scrollHeight, behavior: 'smooth'})
    },
    removeProductItem () {
      if (this.selectedRow.length) {
        const temp = [...this.selectedRow]
        for (let i in temp) {
          this.$refs.pdItem[temp[i]].isChecked = false
          this.selectedRow.splice(i, 1)
          this.removeContactProduct(temp[i])
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.c-input-time {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 8px 0;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  border-bottom: 1px solid rgba(0,0,0,.42);
}
.change-to-white-color
  color #FFFFFF
.class-text-align-center
  text-align center
  margin-top 12px
.padding-for-list-btn
  padding-top 0 !important
  padding-bottom  15px !important
.margin-8
  margin 8px !important

.without_ampm::-webkit-datetime-edit-ampm-field
  display: none

input[type=time]::-webkit-clear-button
  -webkit-appearance: none
  -moz-appearance: none
  -o-appearance: none
  -ms-appearance:none
  appearance: none
  margin: -10px
>>>.col {
  padding-top: 0;
  padding-bottom: 0;
}
.table-wrapper {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 12px;
}

.product-title {
  background-color: #f5f5f5;
  position: sticky;
  position: --webkit-sticky;
  top: 0;
  z-index: 1;
  &:first-child {
    vertical-align: bottom;
    >>>.v-input__slot {
      margin-bottom: 0;
    }
  }
  &__title {
    vertical-align: -webkit-baseline-middle;
    vertical-align: -moz-middle-with-baseline;
  }
  &__action {
    float: right;
  }
}
#table-right {
  border-collapse: separate;
  border-spacing: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Contact/ContactInfo.vue